import React from "react";
import { FaFacebook, FaInstagram, FaGlobe } from "react-icons/fa";
import { useParams } from "react-router-dom";
import api from "../api";


const SocialMedia = ({ social_urls, color = "text-light" }) => {
  const { event_id } = useParams();
  const handleClick = async (url_clicked) => {
    // Post url encoded
    try {
      await api.get(`/click?url=` + encodeURIComponent(url_clicked) + "&eid=" + event_id);
    } catch (error) {
      console.error("Error logging click:", error);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      {/* Instagram Link */}
      {social_urls?.instagram && (
        <a
          href={social_urls.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className={`${color} mx-3`}
          onClick={() => handleClick(social_urls.instagram)} // Call webhook

        >
          <FaInstagram size={24} />
        </a>
      )}

      {/* Facebook Link */}
      {social_urls?.facebook && (
        <a
          href={social_urls.facebook}
          target="_blank"
          rel="noopener noreferrer"
          className={`${color} mx-3`}
          onClick={() => handleClick(social_urls.facebook)} // Call webhook
        >
          <FaFacebook size={24} />
        </a>
      )}

      {/* Website Link */}
      {social_urls?.website && (
        <a
          href={social_urls.website}
          target="_blank"
          rel="noopener noreferrer"
          className={`${color} mx-3`}
          onClick={() => handleClick(social_urls.website)} // Call webhook
        >
          <FaGlobe size={24} />
        </a>
      )}
    </div>
  );
};

export default SocialMedia;
